'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ButtonMicro = require('../../blocks/ButtonMicro');

var _ButtonMicro2 = _interopRequireDefault(_ButtonMicro);

var _modifiers = require('../../utils/modifiers');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BC_BUTTON_MICRO_CONTEXT = '__BC_BUTTON_MICRO_CONTEXT__';

function withButtonMicroProps(WrappedComponent) {
  function WithButtonMicroProps(props, context) {
    var propsFromButtonMicro = context[BC_BUTTON_MICRO_CONTEXT];
    return _react2.default.createElement(WrappedComponent, _extends({}, propsFromButtonMicro, props));
  }

  WithButtonMicroProps.contextTypes = _defineProperty({}, BC_BUTTON_MICRO_CONTEXT, _propTypes2.default.shape({
    modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
  }).isRequired);

  WithButtonMicroProps.displayName = 'ButtonMicro.' + (WrappedComponent.displayName || WrappedComponent.name || '');

  return WithButtonMicroProps;
}

var ButtonMicro = function (_Component) {
  _inherits(ButtonMicro, _Component);

  function ButtonMicro() {
    _classCallCheck(this, ButtonMicro);

    return _possibleConstructorReturn(this, (ButtonMicro.__proto__ || Object.getPrototypeOf(ButtonMicro)).apply(this, arguments));
  }

  _createClass(ButtonMicro, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _defineProperty({}, BC_BUTTON_MICRO_CONTEXT, {
        disabled: this.props.disabled,
        modifiers: this.props.modifiers
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var buttonMicroModifiers = (0, _modifiers.modifiersForComponent)(this.props.modifiers, _ButtonMicro2.default);
      return _react2.default.createElement(_ButtonMicro2.default, _extends({}, this.props, { modifiers: buttonMicroModifiers }));
    }
  }]);

  return ButtonMicro;
}(_react.Component);

ButtonMicro.Icon = withButtonMicroProps(_Icon2.default);
ButtonMicro.Text = withButtonMicroProps(_Text2.default);
ButtonMicro.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};
ButtonMicro.defaultProps = {
  disabled: false,
  modifiers: []
};
ButtonMicro.childContextTypes = _defineProperty({}, BC_BUTTON_MICRO_CONTEXT, _propTypes2.default.object.isRequired);
exports.default = ButtonMicro;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/ButtonMicro/index.js
// module id = 1622
// module chunks = 2